import React from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "../../pages/Dashboard";
import Skill from "../../pages/Skills";
import ProductDescription from "../../pages/ProductDescription";
import EditProductDescription from "../../pages/EditProductDescription";
import Email from "../../pages/Email";
import EmailTemplates from "../Email/EmailTemplate";
import Blog from "../../pages/Blog";
import GenerateBlog from "../../pages/GenerateBlog";
import CreateEmail from "../../pages/CreateEmail";
import Tasks from "../../pages/Task";
import CompanyManagement from "../../pages/CompanyManagement";
import FreeFormContent from "../../pages/Skills/FreeFormContent";
import CreateFreeFormContent from "../../pages/Skills/CreateFreeFormContent";
import EditFreeFormContent from "../../pages/Skills/EditFreeFormContent";
import PreviewFreeFormContent from "../../pages/Skills/PreviewFreeFormContent";
import Chat from "../../pages/Skills/Chat";
import ChatBot from "../../pages/Skills/ChatBot";
import DiyAgentPlayground from "../../pages/Skills/DiyAgentPlayground";
import DiyAgentPreview from "../../pages/Skills/DiyAgentPreview";
import { ProtectedRoute } from "./ProtectedRoute";
import PreviewEmail from "../../pages/previewEmail";
import EditEmail from "../../pages/EditEmail";
import Accountbilling from "../../pages/Accountbilling";
import PreviewPage from "../../pages/Preview";
import KeywordCluster from "../../pages/Blog/KeywordCluster";
import GenerateOutline from "../../pages/Blog/GenerateOutline";
import BlogPreview from "../../pages/Blog/BlogPreview";
import BlogPlayground from "../../components/GenerateBlog/BlogPlayground";
import { ToastContainer } from "react-toastify";

const Routing = () => {
  return (
    <>
      <ToastContainer />
      <Routes>
        {/* Public routes - accessible without authentication */}
        <Route
          path="/skills/blog/blog-preview/:blogId"
          element={<BlogPreview />}
        />
        <Route
          path="/skills/free-form-content/preview/:contentId"
          element={<PreviewFreeFormContent />}
        />
        <Route
          path="/skills/diy-agent/preview/:postId"
          element={<DiyAgentPreview />}
        />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/skills" element={<Skill />} />
                <Route
                  path="/skills/product-description"
                  element={<ProductDescription />}
                />
                <Route
                  path="/edit-product-description"
                  element={<EditProductDescription />}
                />
                <Route
                  path="/edit-product-description/:productId"
                  element={<EditProductDescription />}
                />
                <Route path="/skills/email" element={<Email />} />
                <Route path="/skills/free-form-content" element={<FreeFormContent />} />
                <Route
                  path="/skills/free-form-content/create"
                  element={<CreateFreeFormContent />}
                />
                <Route
                  path="/skills/free-form-content/edit"
                  element={<EditFreeFormContent />}
                />
                <Route
                  path="/skills/free-form-content/preview/:contentId?"
                  element={<PreviewFreeFormContent />}
                />
                <Route
                  path="/skills/email/email-template"
                  element={<EmailTemplates />}
                />
                <Route
                  path="/skills/email/create-email"
                  element={<CreateEmail />}
                />
                <Route
                  path="/skills/email/preview-email"
                  element={<PreviewEmail />}
                />
                <Route path="/skills/blog" element={<Blog />} />
                <Route path="/skills/chat" element={<Chat />} />
                <Route path="/skills/chat/chat_bot" element={<ChatBot />} />
                {/* Dynamic route for DIY agent playground */}
                <Route path="/skills/:agentName/playground" element={<DiyAgentPlayground />} />
                {/* Dynamic route for DIY agents - must be after all specific routes */}
                <Route path="/skills/:agentName" element={<Skill />} />
                <Route
                  path="/skills/blog/keyword-cluster"
                  element={<KeywordCluster />}
                />
                <Route
                  path="/skills/blog/generate-outline"
                  element={<GenerateOutline />}
                />
                <Route
                  path="/skills/blog/generate-blog"
                  element={<GenerateBlog />}
                />
                <Route
                  path="/skills/blog/blog-playground"
                  element={<BlogPlayground />}
                />
                <Route path="/tasks" element={<Tasks />} />
                <Route
                  path="/company-management"
                  element={<CompanyManagement />}
                />
                <Route
                  path="/skills/email/edit-email"
                  element={<EditEmail />}
                />
                <Route path="/accountbilling" element={<Accountbilling />} />
                <Route path="/preview" element={<PreviewPage />} />
                <Route
                  path="/preview-product-description/:documentId"
                  element={<PreviewPage />}
                />
                <Route
                  path="/preview-blog/:documentId"
                  element={<PreviewPage />}
                />
              </Routes>
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
};

export default Routing;
